const initialState = {
  samplesList: [],
};

export const samplesReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "samples")
    return action.execute(state);
  return state;
};
